import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { LeftOutlined } from "@ant-design/icons";

interface BackButtonProps {
  to?: string;
  label?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ to, label = "" }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <Button icon={<LeftOutlined />} onClick={handleBack} type="link" className="back-button-fm">
      <span style={{textDecoration: "underline"}}>Back to {label}</span>
    </Button>
  );
};

export default BackButton;
